import { GenericDialog } from '@/components/shared/GenericDialog';
import { abyssColors } from '@/theme/colors';
import { Button, Checkbox, FormControlLabel, FormGroup, Stack, Typography } from '@mui/material';
import { useAtom, useSetAtom } from 'jotai';
import {
  ignoreMissingComments,
  showMissingCommentsDialog,
  suppressMissingCommentsCheck,
} from '../state/atoms';
import { useCallback } from 'react';

export const MissingCommentsDialog = () => {
  const [open, setOpen] = useAtom(showMissingCommentsDialog);
  const setSupression = useSetAtom(suppressMissingCommentsCheck);
  const setIgnore = useSetAtom(ignoreMissingComments);

  const handleContinue = useCallback(() => {
    setOpen(false);
    setIgnore(true);
  }, [setIgnore, setOpen]);

  const handleAddComments = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  return (
    <GenericDialog
      open={open}
      dialogStyles={{
        '.MuiDialog-container': {
          alignItems: 'baseline',
          paddingTop: '14.8rem',
        },
      }}
      paperStyles={{
        maxWidth: '52.6rem',
      }}
      titleStyles={{
        padding: '2.4rem 2.4rem 0.8rem 2.4rem',
      }}
      onClose={() => setOpen(false)}
      title="Missing comments"
      content={
        <Stack gap="1.6rem">
          <Typography
            fontSize="1.4rem"
            color={abyssColors.primary[700]}
            lineHeight={1.43}
            letterSpacing="normal"
          >
            You haven't added any comments against the values. To view comments for specific values
            in the Description column of the exported CSV file, please add them here.
          </Typography>
          <FormGroup>
            <FormControlLabel
              sx={{
                '.MuiFormControlLabel-label': {
                  fontSize: '1.4rem',
                  lineHeight: '2rem',
                  color: abyssColors.primary[700],
                  letterSpacing: 'normal',
                },
              }}
              control={
                <Checkbox
                  size="small"
                  sx={{ paddingY: 0 }}
                  onClick={() => setSupression((oldValue) => !oldValue)}
                />
              }
              label="Don't show this message again."
            />
          </FormGroup>
        </Stack>
      }
      actions={
        <Stack
          gap="1.15rem"
          direction="row"
          sx={{
            '.MuiButton-root': {
              padding: '0.6rem 1.6rem',
              textTransform: 'uppercase',
              fontWeight: 500,
              lineHeight: '2.4rem',
              letterSpacing: '0.04rem',
              fontSize: '1.4rem',
            },
          }}
        >
          <Button onClick={handleContinue}>Continue Without Comments</Button>
          <Button variant="contained" sx={{ fontWeight: 500 }} onClick={handleAddComments}>
            Add Comments
          </Button>
        </Stack>
      }
      actionsStyles={{ mr: 3, pb: 3, pt: '1.4rem' }}
    />
  );
};
